import axios from "axios";
import { getCookies, setCookies, removeCookies } from "../services/Cookies";
import toast from "react-hot-toast";
import SessionManager from "../components/sessionManager/SessionManager";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});



// Request Interceptor to add token to headers
api.interceptors.request.use(
  (config) => {
    const token = getCookies("token"); // Access token
    if (token && token !== "null") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);





export { api };

